import { AxiosError } from '@price-for-profit/micro-services';
import { format } from 'date-fns/fp';
import { Product } from 'shared/types';

export const DATE_TIME_MIN = '0001-01-01T00:00:00';

export const formatDate = format('MM-dd-yy hh:mm:ss aa');

export const isDefaultDotnetDate = (date: string) => date === DATE_TIME_MIN;

export const calculateMargin = (price: number, cost: number) => ((price - cost) / price) * 100;

export const toFixed = (places: number) => (value: number) => Number(Number(value).toFixed(places));

export const fixed2Places = toFixed(2);

export const fixed4Places = toFixed(4);

export const compareToMarginFloor = (margin: number, marginFloor: number) =>
    fixed2Places(margin) < fixed2Places(marginFloor);

export const arrayEquals = <T extends string | number>(source: T[]) => (target: T[]) =>
    target.every((x, i) => x === source[i]);

export const chunkArray = <T>(items: T[], chunkSize: number): T[][] =>
    items.reduce<T[][]>((rows, data, index: number) => {
        if (index % chunkSize === 0) {
            rows.push([data]);
        } else {
            rows[Boolean(rows.length) ? rows.length - 1 : 0].push(data);
        }
        return rows;
    }, []);

export function isAxiosError<T>(error: any): error is AxiosError<T> {
    return error.isAxiosError;
}

export function formatProduct(product: Product) {
    return {
        ...product,
        currentPrice: fixed2Places(product.currentPrice),
        productCostUnit: fixed2Places(product.productCostUnit),
        quantityBreak2: fixed2Places(product.quantityBreak2),
        quantityBreak3: fixed2Places(product.quantityBreak3),
        quantityBreak4: fixed2Places(product.quantityBreak4),
        quantityBreak5: fixed2Places(product.quantityBreak5),
        recommendedPrice: fixed2Places(product.recommendedPrice),
        revisedPrice: fixed2Places(product.revisedPrice),
        competitiveSkuPrice: fixed2Places(product.competitiveSkuPrice),

        productMargin: fixed4Places(product.productMargin),
        revisedMargin: fixed4Places(product.revisedMargin),
        priceChange: fixed4Places(product.priceChange),
        marginFloor: fixed4Places(product.marginFloor),
    };
}
